module.exports = __webpack_public_path__ + "img/20220406.27f2581e.png";